import React, { createContext, useReducer } from "react";
import ProductsReducer from "../reducers/products.reducer";
import { productsColumns } from "../../statics/table-columns/productsColumns";

const initialState: any = {
  products: [],
  filter: {
    searchText: "",
    status: null,
  },
  columns: productsColumns,
  options: {
    withSort: true,
    sortDirection: "asc",
    sortColumn: "",
  },
  pagination: {
    currentPage: 1,
    items: 15,
    totalPages: 1,
    total: 0,
  },
};

export const ProductsContext = createContext(initialState);
export const ProductsProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(ProductsReducer, initialState);

  function setProducts(products: any[]) {
    dispatch({
      type: "SET_PRODUCTS",
      payload: { products },
    });
  }

  function sort(params: any) {
    dispatch({
      type: "SORT_PRODUCTS",
      payload: { params },
    });
  }

  function setFilter(filter: any) {
    dispatch({
      type: "SET_FILTER",
      payload: { filter },
    });
  }

  function setPagination(params: any) {
    dispatch({
      type: "SET_PAGINATION",
      payload: { params },
    });
  }

  return (
    <ProductsContext.Provider
      value={{
        ...state,
        setProducts,
        setFilter,
        setPagination,
        sort,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};
